
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Définition du Brand Equity : l’agence ALEO vous l’explique",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Comprenez l’importance du capital marque pour votre entreprise, découvrez comment l’évaluer et adoptez les meilleures pratiques pour valoriser votre Brand Equity.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Définition du Brand Equity : l’agence ALEO vous l’explique",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Comprenez l’importance du capital marque pour votre entreprise, découvrez comment l’évaluer et adoptez les meilleures pratiques pour valoriser votre Brand Equity.",
        },
      ],
    };
  },
};
